const SystemFilter = {
  UNLICENSED_SYSTEMS: {
    ID_SAF_TF_TEILMENGE: 'TX_NO_VALID_SYSTEM_LICENSE',
    BEZEICHNUNG: 'TX_NO_VALID_SYSTEM_LICENSE',
    CATEGORY: 'SYSTEM',
  },
};

export default SystemFilter;
